import type { TypedUseSelectorHook } from 'react-redux'

import { configureStore } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'

import * as client from '../lib/http'
import { setStore } from '../lib/state'

import * as middleware from './middleware'
import { reducer } from './reducer'

export let store = configureStore({
  reducer,
  middleware: [
    // middleware.redirect(),
    middleware.igao(),
    middleware.async(client),

    ...(process.env.NODE_ENV === 'development'
      ? [
        middleware.logErrors
      ]
      : []
    )
  ]
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

setStore(store)
